import * as React from 'react';
import { useStableCallback } from './use-stable-callback';

/**
 * https://usehooks.com/useOnClickOutside/
 */
export const useOnClickOutside = (
    ref: React.MutableRefObject<HTMLElement> | HTMLElement,
    handler: (event: any) => void,
): void => {
    const stableHandler = useStableCallback(handler);
    React.useEffect(() => {
        const listener = (event: MouseEvent | TouchEvent) => {
            const element = ref instanceof HTMLElement ? ref : ref?.current;

            // Do nothing if clicking ref's element or descendent elements
            if (!element || element.contains(<Node>event.target)) {
                return;
            }

            stableHandler(event);
        };

        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref]);
};
